import { emsApi } from '@/api/emsApi';
import type { ChatMessage, NewChatMessageBody } from '@/signalr';

export async function fetchChatMessagesForIncident(incidentId: string): Promise<ChatMessage[] | null> {
  const { data, response } = await emsApi.GET('/mobile-app/v1/incident/{id}/chat-messages', {
    params: { path: { id: incidentId } },
  });

  if (!response.ok) {
    throw new Error(`Failed to load chat messages for incident ${incidentId} (HTTP ${response.status})`);
  }

  return (data as unknown as ChatMessage[] | null | undefined) ?? null;
}

export async function sendNewChatMessage(incidentId: string, body: NewChatMessageBody): Promise<void> {
  const { response } = await emsApi.POST('/mobile-app/v1/incident/{id}/chat-messages', {
    params: { path: { id: incidentId } },
    body: body as never,
  });

  if (!response.ok) {
    throw new Error(`Failed to send chat message for incident ${incidentId} (HTTP ${response.status})`);
  }
}

export async function activateChatForIncident(incidentId: string): Promise<void> {
  const { response } = await emsApi.POST('/mobile-app/v1/incident/{id}/activate-chat', {
    params: { path: { id: incidentId } },
  });

  if (!response.ok) {
    throw new Error(`Failed to activate chat for incident ${incidentId} (HTTP ${response.status})`);
  }
}

export async function translateChatMessage(text: string, targetCulture: string): Promise<string> {
  const { data, response } = await emsApi.POST('/portal/v1/translate', {
    body: { text, targetCulture } as never,
  });

  if (data === undefined) {
    throw new Error(`Failed to translate a chat message (HTTP ${response.status})`);
  }

  return (data as unknown as { translatedText: string }).translatedText;
}
